/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Title_AccentInputs */

const en_blog_title_accent = /** @type {(inputs: Blog_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly.`)
};

const es_blog_title_accent = /** @type {(inputs: Blog_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly.`)
};

const de_blog_title_accent = /** @type {(inputs: Blog_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly.`)
};

const zh_blog_title_accent = /** @type {(inputs: Blog_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新文章。`)
};

const ar_blog_title_accent = /** @type {(inputs: Blog_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly.`)
};

const fr_blog_title_accent = /** @type {(inputs: Blog_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly.`)
};

const vi_blog_title_accent = /** @type {(inputs: Blog_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly.`)
};

const sw_blog_title_accent = /** @type {(inputs: Blog_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly.`)
};

const th_blog_title_accent = /** @type {(inputs: Blog_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

const bs_blog_title_accent = /** @type {(inputs: Blog_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marka Eglyja.`)
};

const ja_blog_title_accent = /** @type {(inputs: Blog_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新記事。`)
};

const ko_blog_title_accent = /** @type {(inputs: Blog_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최신 소식.`)
};

const pt_blog_title_accent = /** @type {(inputs: Blog_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly.`)
};

const it_blog_title_accent = /** @type {(inputs: Blog_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly.`)
};

const sv_blog_title_accent = /** @type {(inputs: Blog_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly.`)
};

const nl_blog_title_accent = /** @type {(inputs: Blog_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly.`)
};

const da_blog_title_accent = /** @type {(inputs: Blog_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly.`)
};

const nb_blog_title_accent = /** @type {(inputs: Blog_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly.`)
};

const fi_blog_title_accent = /** @type {(inputs: Blog_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Eglyltä.`)
};

const pl_blog_title_accent = /** @type {(inputs: Blog_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marka Egly’ego.`)
};

const ru_blog_title_accent = /** @type {(inputs: Blog_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly.`)
};

const tr_blog_title_accent = /** @type {(inputs: Blog_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`en son haberler.`)
};

const hi_blog_title_accent = /** @type {(inputs: Blog_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ताज़ा पोस्ट।`)
};

const id_blog_title_accent = /** @type {(inputs: Blog_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly.`)
};

const ms_blog_title_accent = /** @type {(inputs: Blog_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly.`)
};

const cs_blog_title_accent = /** @type {(inputs: Blog_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marka Eglyho.`)
};

const el_blog_title_accent = /** @type {(inputs: Blog_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly.`)
};

const he_blog_title_accent = /** @type {(inputs: Blog_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly.`)
};

const af_blog_title_accent = /** @type {(inputs: Blog_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly.`)
};

const hu_blog_title_accent = /** @type {(inputs: Blog_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`legfrissebb írásai.`)
};

/**
* | output |
* | --- |
* | "Mark Egly." |
*
* @param {Blog_Title_AccentInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const blog_title_accent = /** @type {((inputs?: Blog_Title_AccentInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Title_AccentInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_blog_title_accent(inputs)
	if (locale === "de") return de_blog_title_accent(inputs)
	if (locale === "zh") return zh_blog_title_accent(inputs)
	if (locale === "ar") return ar_blog_title_accent(inputs)
	if (locale === "fr") return fr_blog_title_accent(inputs)
	if (locale === "vi") return vi_blog_title_accent(inputs)
	if (locale === "sw") return sw_blog_title_accent(inputs)
	if (locale === "th") return th_blog_title_accent(inputs)
	if (locale === "bs") return bs_blog_title_accent(inputs)
	if (locale === "ja") return ja_blog_title_accent(inputs)
	if (locale === "ko") return ko_blog_title_accent(inputs)
	if (locale === "pt") return pt_blog_title_accent(inputs)
	if (locale === "it") return it_blog_title_accent(inputs)
	if (locale === "sv") return sv_blog_title_accent(inputs)
	if (locale === "nl") return nl_blog_title_accent(inputs)
	if (locale === "da") return da_blog_title_accent(inputs)
	if (locale === "nb") return nb_blog_title_accent(inputs)
	if (locale === "fi") return fi_blog_title_accent(inputs)
	if (locale === "pl") return pl_blog_title_accent(inputs)
	if (locale === "ru") return ru_blog_title_accent(inputs)
	if (locale === "tr") return tr_blog_title_accent(inputs)
	if (locale === "hi") return hi_blog_title_accent(inputs)
	if (locale === "id") return id_blog_title_accent(inputs)
	if (locale === "ms") return ms_blog_title_accent(inputs)
	if (locale === "cs") return cs_blog_title_accent(inputs)
	if (locale === "el") return el_blog_title_accent(inputs)
	if (locale === "he") return he_blog_title_accent(inputs)
	if (locale === "af") return af_blog_title_accent(inputs)
	if (locale === "hu") return hu_blog_title_accent(inputs)
	return en_blog_title_accent(inputs)
});